// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    appVersion: require('../../package.json').version,
    production: true,
    codCliente: 'BSANTANDER',
    docEmpresa: '97036000K',
    

    urlAmbiente:'https://parcomercios.getnet.cl',
    urlPortal: 'parcomercios.getnet.cl'


    // Configuración Entra ID
    ,entraId: {
    clientId: '76c5d6c6-3b36-42e9-b9ba-a1e7f256d6bb',
    authority: 'https://login.microsoftonline.com/35595a02-4d6d-44ac-99e1-f9ab4cd872db',
    redirectUri: '/callback', 
    logouturi: '/login',
    scopes: ['openid', 'profile', 'email']
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
